import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import 'rc-dropdown/assets/index.css';
import Routes from './components/Routes'
import {Route} from 'react-router'
import {CorBusiness} from "cor-business";
import {HOME_PAGE_URI, NOTIFICATIONS_PAGE_URI} from "./constants/uri.constant";
import {NotificationService} from "./services";
import "./components/TiptapEditor/styles/_variables.scss"
import "./components/TiptapEditor/styles/_keyframe-animations.scss"
import {WebsocketProvider} from "./context/websocket.context";

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
    <CorBusiness config={{
        apiBaseUrl: import.meta.env.VITE_API_AUTH_BASE_URL,
        afterAuthRedirectUrl: HOME_PAGE_URI,
        notificationsUrl: NOTIFICATIONS_PAGE_URI,
        getUnreadNotificationsCount: () => NotificationService.unreadCount()
    }}>
        <Route path={'*'} element={<Routes />}/>
    </CorBusiness>
);
